// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

declare const APP_VERSION: string;

/**
 * A value from env.js, or the fallback when it is not set.
 */
function fromEnv<T extends string | number | boolean>(
  key: string,
  fallback: T
): T {
  const value = window.env?.[key];
  if (value === undefined || value === null) return fallback;
  if (typeof value === 'string' && value.trim() === '') return fallback;
  return value as T;
}

export const environment = {
  // Empty: requests are relative to the portal's own origin, which the dev
  // server proxies to the API (locally and in the e2e run).
  apiUrl: fromEnv('API_URL', ''),
  isDev: Boolean(fromEnv('DEV', false)),
  supportEmail: fromEnv('SUPPORT_EMAIL', 'support@zspace.com'),
  temporaryUserPermissionMaxDaysDuration: fromEnv(
    'TEMPORARY_USER_PERMISSION_MAX_DAYS_DURATION',
    '30'
  ),
  clarityProjectId: fromEnv('CLARITY_PROJECT_ID', ''),
  internalUserEmailDomains: fromEnv(
    'INTERNAL_USER_EMAIL_DOMAINS',
    'zspace.com,teamsparq.com'
  ),
  partnerUserEmailDomains: fromEnv(
    'PARTNER_USER_EMAIL_DOMAINS',
    'partners.com'
  ),
  termsOfUseUrl: fromEnv(
    'ZSPACE_TERMS_OF_USE_URL',
    'https://zspace.com/legal/terms-of-use'
  ),
  privacyPolicyUrl: fromEnv(
    'ZSPACE_PRIVACY_POLICY_URL',
    'https://zspace.com/legal/privacy-policy'
  ),
  legalUrl: fromEnv('ZSPACE_LEGAL_URL', 'https://zspace.com/legal'),
  supportUrl: fromEnv(
    'ZSPACE_SUPPORT_URL',
    'https://support.zspace.com/s/article/zSpace-Management-Hub?language=en_US'
  ),
  // No DSN leaves Sentry disabled.
  sentryDsn: fromEnv('SENTRY_DSN', ''),
  sentryEnvironment: fromEnv('SENTRY_ENVIRONMENT', ''),
  appVersion: APP_VERSION,
  managementHubLicenseStartDate: fromEnv(
    'MANAGEMENT_HUB_LICENSE_START_DATE',
    '2019-01-01T12:00:00.000Z'
  ),
};
